<template>
  <svg class="svg" width="82" height="196" viewBox="0 0 82 196" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M105 8L15 98L105 188" stroke="url(#paint0_linear_green)" stroke-width="20"/>
    <defs>
      <linearGradient id="paint0_linear_green" x1="15" y1="98" x2="105" y2="98" gradientUnits="userSpaceOnUse">
        <stop stop-color="#2EF525"/>
        <stop offset="1" stop-color="#148100"/>
      </linearGradient>
    </defs>
</svg>

</template>
<script>
export default {
  name: "LeftArrowGreen",
}
</script>
<style lang="scss" scoped>
.svg{
  width: 90px;
  height: 180px;
  
}

</style>